export function slugify(heading: string) {
  return (
    heading
      .toLowerCase()
      /**
       * We keep only Unicode word characters (letters, numbers, etc.), spaces, and hyphens.
       * The 'u' flag enables Unicode support, allowing Japanese, Korean, and other
       * non-ASCII characters to be preserved in the slug.
       */
      .replace(/[^\p{L}\p{N}\s_-]/gu, '')
      /**
       * We replace spaces with hyphens.
       */
      .replace(/\s+/g, '-')
  )
}
